import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { FC } from "react";
import { downloadCustomerTemplate } from "../../../utils";

/**
 * Customer list template download component
 * Provides a link to download the customer list template
 */
export const ICPCustomerListTemplate: FC = () => {
  return (
    <Typography variant="body2">
      <Link
        component="button"
        onClick={downloadCustomerTemplate}
        fontWeight="bold"
        sx={{
          textDecoration: "none",
          cursor: "pointer",
        }}
      >
        Download a template
      </Link>{" "}
      to get you started.
    </Typography>
  );
};
